import React from "react";

import * as Icons from "/component/base/Icon";
import Text from "/component/base/Text";
import { layout } from "/styles";
import { formatDate } from "/util/date";

import { ContentWrapper, TextContent, TitleContent } from "./CareSummaryListItem.styles";

interface Props {
  document: {
    providerName: string;
    dateString: string;
  };
}

const CareSummaryListItem = ({ document }: Props) => {
  const { providerName, dateString } = document;
  const docDate = formatDate(dateString, "MMMM dd, yyyy");

  return (
    <div
      css={[
        layout.flexCenterHorizontal,
        layout.margin("standard", "none"),
        layout.spacedChildrenHorizontal("standard"),
      ]}
    >
      <div>
        <Icons.FilePlus
          color="brandSecondary"
          background={{ size: 48, color: "brandSecondaryLight" }}
        />
      </div>
      <ContentWrapper>
        <TextContent>
          <TitleContent>
            <Text color={"textPrimary"} variant="body1Bold">
              {docDate}
            </Text>
          </TitleContent>

          {providerName && (
            <Text color="textSecondary" variant="body2">
              {providerName}
            </Text>
          )}
        </TextContent>
      </ContentWrapper>
    </div>
  );
};

export default CareSummaryListItem;
